import type { DealerOptionItemDto } from '@api/machines'

import { BRAND_FAMILIES } from '../constants'

export const calculateLengthWithoutSpaces = (name: string) =>
  name?.replace(/ /g, '').length ?? 0

export const handleIdGeneration = () => {
  const timeStamp = new Date().getTime()
  return timeStamp.toString()
}

export const formattedTransportType = (value: string) =>
  value
    ?.toLowerCase()
    .split('')
    .map((char, idx) => (idx === 0 ? char.toUpperCase() : char))
    .join('')

export const getDealerFitName = (item: DealerOptionItemDto) => {
  if (Number(item.id) < 0) {
    return item.itemName
  }

  let result = ''

  const brandPart =
    item?.family === BRAND_FAMILIES.HITCH ||
    item?.family === BRAND_FAMILIES.BUCKET
      ? `- ${item?.brand}`
      : ''

  const quantityPart = (item.quantity ?? 0) > 1 ? `(${item.quantity})` : ''

  if (item.type) {
    result += item.type
  }
  if (item.subType1) {
    result += ` ${item.subType1}`
  }
  if (item.subType2) {
    result += ` ${item.subType2}`
  }
  if (brandPart.length > 0) {
    result += ` ${brandPart}`
  }
  if (quantityPart.length > 0) {
    result += ` ${quantityPart}`
  }
  return result
}

export const helperText = (
  newItemName: string,
  emptyErrorTranslation: string,
  lengthErrorTranslation: string,
  genericTextTranslation?: string
) => {
  const lengthWithoutSpaces = calculateLengthWithoutSpaces(newItemName)

  if (lengthWithoutSpaces === 0) {
    return emptyErrorTranslation
  }
  if (lengthWithoutSpaces < 4) {
    return lengthErrorTranslation
  }
  return genericTextTranslation ?? null
}

export const truncateText = (text: string, maxTextLength: number) => {
  if (text.length > maxTextLength && maxTextLength >= 0) {
    return text.slice(0, maxTextLength)
  }
  return text
}

/**
 * Capitalizes the first letter of a string while keeping the rest of the text as is
 * @param text The string to capitalize
 * @returns The string with its first letter capitalized
 */
export const capitalizeFirstLetter = (text: string): string => {
  if (!text || typeof text !== 'string' || text.length === 0) {
    return text
  }

  return text.charAt(0).toUpperCase() + text.slice(1)
}
